import { AUTH_DEVICE_KEY } from './storage-keys';

/**
 * 浏览器环境下的设备标识（桌面端会由 Electron 主进程注入真机指纹）。
 * 这里只做稳定哈希，保证同一台机器同一浏览器重复访问结果一致。
 */
export function detectDeviceId(): string {
  const cached = localStorage.getItem(AUTH_DEVICE_KEY);
  if (cached) return cached;

  const seed = [
    navigator.userAgent,
    navigator.language,
    String(new Date().getTimezoneOffset()),
    `${window.screen.width}x${window.screen.height}`,
    navigator.platform,
  ].join('|');

  let a = 0;
  let b = 0;
  for (let i = 0; i < seed.length; i += 1) {
    const code = seed.charCodeAt(i);
    a = ((a << 5) - a + code) | 0;
    b = ((b << 7) + b + code) | 0;
  }
  const id = `${Math.abs(a).toString(36)}${Math.abs(b).toString(36)}`.padEnd(32, '0');
  localStorage.setItem(AUTH_DEVICE_KEY, id);
  return id;
}
